export class SpecialProperty {

    public getValue: Function; // (p_obj:Object, p_parameters:Array, p_extra:Object): Number
    public setValue: Function; // (p_obj:Object, p_value:Number, p_parameters:Array, p_extra:Object): Void
    public parameters: Array<any>;
    public preProcess: Function; // (p_obj:Object, p_parameters:Array, p_originalValueComplete:Object, p_extra:Object): Number

    /**
     * Builds a new special property object.
     *
     * @param        p_getFunction        Function    Reference to the function used to get the special property value
     * @param        p_setFunction        Function    Reference to the function used to set the special property value
     */
    constructor(p_getFunction: Function, p_setFunction: Function, p_parameters: Array<any> = null, p_preProcessFunction: Function = null) {
        this.getValue = p_getFunction;
        this.setValue = p_setFunction;
        this.parameters = p_parameters;
        this.preProcess = p_preProcessFunction;
    }

    /**
     * Converts the instance to a string that can be used when trace()ing the object
     */
    public toString(): string {
        let value: string = '';
        value += '[SpecialProperty ';
        value += 'getValue:' + this.getValue;
        value += ', ';
        value += 'setValue:' + this.setValue;
        value += ', ';
        value += 'parameters:' + this.parameters;
        value += ', ';
        value += 'preProcess:' + this.preProcess;
        value += ']';
        return value;
    }
}
